import { ReactElement } from 'react';

interface BedColumnProps {
  img: string;
  title: string;
  description: string;
  alt: string;
}

const BedColumn = ({ img, title, description, alt }: BedColumnProps): ReactElement => (
  <div className="bed-column">
    <div className="bed-column-img">
      <img src={img} alt={alt} loading="lazy" decoding="async" fetchPriority="low" />
    </div>
    <div className="bed-column-text">
      <h3 className="bed-column-title">{title}</h3>
      <p className="bed-column-description">{description}</p>
    </div>
  </div>
);

export default BedColumn;
